import omit from 'lodash/omit';

// Turns a copied driver into the base for a new one; source-specific fields are dropped.
// hasPermission described the source driver, so it only decides whether its account is kept as the default.
export function preparePastedDriver(copied) {
  const item = omit(copied, ['id', 'createdAt', 'updatedAt', 'Tenant', 'hasPermission']);

  if (copied.hasPermission === false) {
    item.accountId = null;
  }

  return item;
}
